import { executeNetworkAsync } from "../../helper/handler/network";
import { clientAxiosInstance } from "../../types/swrFetcher";

export const authenticateUserController = async (
  email: string,
  password: string,
  captchaToken?: string
) => {
  const payload: any = { email, password };
  if (captchaToken) {
    payload.captchaToken = captchaToken;
  }

  const networkCall = async () =>
    await clientAxiosInstance().post("/api/auth/authenticateUser", payload);

  const [result, error] = await executeNetworkAsync(networkCall);
  return [result, error];
};
